// Darius — Apprehend: slashes the target, applying Hemorrhage (bleed stacks).
// After 5 stacks on the target, damage is doubled. Also heals Darius for
// 15% of the target's missing HP.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const dariusApprehend: Ability = {
  id: "dariusApprehend",
  displayName: "Apprehend",
  description: "Deals 1.5× AD + 50 physical damage and applies 1 bleed stack. After 5 stacks, damage is doubled. Heals Darius for 15% of target's missing HP.",
  iconId: "DariusQ",

  targetShape({ target }) {
    return [target.pos];
  },

  computeHits({ caster, target }): AbilityHit[] {
    const stats = effectiveStats(caster);
    const stacks = target.passiveStacks;
    const baseDmg = physicalDamage(stats.ad * 1.5 + 50);
    const finalDmg = stacks >= 5 ? baseDmg * 2 : baseDmg;

    const targetStats = effectiveStats(target);
    const missingHp = targetStats.maxHp - target.currentHp;
    const healAmt = Math.round(missingHp * 0.075);

    const hits: AbilityHit[] = [
      {
        target,
        amount: finalDmg,
        type: "physical",
        effect: { kind: "bleed", tickDamage: 35, duration: 3 },
      },
    ];

    if (healAmt > 0) {
      hits.push({ target: caster, amount: 0, type: "none", heal: healAmt });
    }

    return hits;
  },
};
